/* eslint-disable require-jsdoc */
export function InfoWindowHtmlWrapper() {}
export function getWindowVenueHtml(venue) {
  if (venue === undefined) {
    var venue = '';
    return '';
  }
  let infowindow_content = '';
  if (
    venue.address !== undefined &&
    venue.address != '' &&
    venue.address != 'None'
  ) {
    var address_area = `<span class = 'hearby-map-venue-address'>${venue.address}</span>`;
  } else {
    var address_area = '';
  }
  if (
    venue.phone !== undefined &&
    venue.phone != '' &&
    venue.phone != 'None' &&
    venue.phone != '#ERROR!' &&
    venue.phone != null
  ) {
    var phone_area = `<span class = 'hearby-map-venue-phone'>Call venue ${venue.phone}</span>`;
  } else {
    var phone_area = '';
  }
  if (
    venue.website !== undefined &&
    venue.website != '' &&
    venue.website != 'None'
  ) {
    // var venue_link = venue.venueWebsite;
    if (venue.website.substring(0, 5) == 'https') {
      var venue_web_address = venue.website.substring(8);
    } else {
      var venue_web_address = venue.website.substring(7);
    }
    const website_len = venue_web_address.length;
    if (venue_web_address.substring(website_len - 1, website_len) == '/') {
      venue_web_address = venue_web_address.substring(0, website_len - 1);
    }
    var full_venue_web_adress = venue.website;
  } else {
    const venue_link = '';
    var venue_web_address = '';
    var full_venue_web_adress = '';
  }
  // const base_img_url = 'https://undrground-images.s3.amazonaws.com/';
  const image_url = venue.venueImage;
  infowindow_content = `<div class = 'hearby-map-venue'>
                            <div class='hearby-map-venue-name'>${
  venue.venueName
}</div>
                            <div class="noevents-image"> <img src= "${
  image_url
}"onerror="this.style.display='none'"></div>
                            ${address_area}
                            ${phone_area}
                            <a class ='venue-detail-map' href= '${full_venue_web_adress}' target="_blank">
                              <span class='venue-map-web-address'>${venue_web_address} </span>
                          </a>
                          <span class = 'hearby-map-venue-no-events-msg'>Check venue website for updates.</span>
                        </div>
                `;
  return infowindow_content;
}

export function getWindowHtml(events) {
  let index = 0;
  const first_index = 0;
  const last_index = events.length - 1;
  let infowindow_content = '';
  let event_img_buffer = '';
  let event_img_counter = 0;
  for (; index < events.length; index++) {
    const event = events[index];
    if (index == first_index) {
      infowindow_content += `<div class = 'hearby-map-venue'><div class='hearby-map-venue-name'>${event.venue}</div><div class = 'hearby-map-venue-events'>`;
      infowindow_content += this.make_infowindow_date(
          event.month,
          event.day,
          event.year,
      );
    }
    infowindow_content += this.create_event_time(event);
    event_img_counter += 1;
    event_img_buffer += this.create_event_img(
        event_img_counter,
        event.eventImage,
    );
    if (index == last_index) {
      infowindow_content += '</div>';
      infowindow_content += `<div class='hearby-map-event-image map-event-images-${event_img_counter.toString()}'>`;
      infowindow_content += event_img_buffer;
      infowindow_content += '</div>';
      infowindow_content += '</div>';
    }
  }
  return infowindow_content;
}
